//Document ready
$(function() {
	introSliderInit();
});

//Intro slider init
function introSliderInit() {
  $('.intro-slider').slick({
    autoplay: true,
    dots: false
  });
}
